import { Theme } from "@mui/material/styles/createTheme";
import { makeStyles } from "@mui/styles";

export const FormErrorPlaceholderStyles = makeStyles((theme: Theme) => ({
    errorPlaceholder: {
        width: "100%",
        height: "20px"
    },
}));
